import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { ChatThreadParams, createChatThread } from "./api"

export function useCreateChatThread(params?: ChatThreadParams, bookIdOverride?: string) {
  const getContext = useApiContext(bookIdOverride)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      chat_threadable_type,
      chat_threadable_id,
    }: {
      chat_threadable_type: string
      chat_threadable_id: string
    }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return createChatThread(context, chat_threadable_type, chat_threadable_id)
    },
    onSuccess: (data) => {
      const prependCreatedThread = (threads: (typeof data)[] | undefined) => {
        if (!threads) return threads
        return [data, ...threads.filter((thread) => thread.id !== data.id)]
      }

      if (params?.chat_threadable_type && params?.chat_threadable_id) {
        queryClient.setQueryData(
          ["chat_threads_list", params.chat_threadable_type, params.chat_threadable_id],
          prependCreatedThread
        )
        queryClient.invalidateQueries({
          queryKey: ["chat_threads_list", params.chat_threadable_type, params.chat_threadable_id],
        })
      } else {
        queryClient.setQueryData(["chat_threads_list"], prependCreatedThread)
        queryClient.invalidateQueries({
          queryKey: ["chat_threads_list"],
        })
      }
      queryClient.setQueryData(["chat_thread", data.id], data)
    },
  })
}
